import { useMemo } from 'react';
import { navigationMenuStructure, type MenuItem } from '../config/navigation';
import { usePermissions } from './usePermissions';

export function useFilteredNavigation() {
  const { canAccessPath, loading } = usePermissions();

  const filteredNavigation = useMemo(() => {
    if (loading) return navigationMenuStructure;

    return navigationMenuStructure
      .map((section) => {
        if (!section.children) {
          // Standalone item
          if (section.path && !canAccessPath(section.path)) return null;
          return section;
        }

        // Filter children by permission
        const accessibleChildren = section.children.filter(
          (child) => !child.path || canAccessPath(child.path)
        );

        // Hide section if no children are accessible
        if (accessibleChildren.length === 0) return null;

        return { ...section, children: accessibleChildren };
      })
      .filter(Boolean) as MenuItem[];
  }, [canAccessPath, loading]);

  return { filteredNavigation, loading };
}
